import { render, staticRenderFns } from "./VariablesCard.vue?vue&type=template&id=5322ffaa&scoped=true&"
import script from "./VariablesCard.vue?vue&type=script&lang=js&"
export * from "./VariablesCard.vue?vue&type=script&lang=js&"
import style0 from "./VariablesCard.vue?vue&type=style&index=0&id=5322ffaa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322ffaa",
  null
  
)

export default component.exports